import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "slug"]

  connect() {
    // Track whether the user has manually edited the slug
    this.manuallyEdited = this.slugTarget.value !== "" &&
      this.slugTarget.value !== this.toSlug(this.sourceTarget.value)
  }

  generate() {
    if (this.manuallyEdited) return

    this.slugTarget.value = this.toSlug(this.sourceTarget.value)
  }

  manualEdit() {
    // If the user clears the slug, resume auto-generation
    if (this.slugTarget.value === "") {
      this.manuallyEdited = false
    } else {
      this.manuallyEdited = true
    }
  }

  toSlug(text) {
    return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // strip accents
      .replace(/[^a-z0-9\s-]/g, "")   // remove non-alphanumeric
      .replace(/\s+/g, "-")            // spaces to hyphens
      .replace(/-+/g, "-")             // collapse multiple hyphens
      .replace(/^-|-$/g, "")           // trim leading/trailing hyphens
  }
}
